import {
  generateSampleNumber,
  newSample,
  Sample,
} from "@/services/backend/samples/types/sample";
import { EntityId } from "@/shared/types/entity-id";
import { Namespace } from "@/shared/types/namespace";
import { Kind } from "@/services/backend/samples/types/kind";

export interface DustDensitySample extends Sample {
  unit: string;
  referenceValue: string;
  value: string;
}

export function newDustDensitySample(
  id: string,
  documentId: EntityId,
  documentNamespace: Namespace | null,
  location: string,
  spot: string,
): DustDensitySample {
  const base = newSample(
    id,
    generateSampleNumber(),
    Kind.DustDensity,
    documentId,
    documentNamespace,
  );

  return {
    ...base,
    location,
    spot,
    unit: "g/m²",
    referenceValue: "<8",
    value: "",
  };
}
